import { render, staticRenderFns } from "./desktop-header.vue?vue&type=template&id=0ae68142&scoped=true&"
import script from "./desktop-header.vue?vue&type=script&lang=ts&"
export * from "./desktop-header.vue?vue&type=script&lang=ts&"
import style0 from "./desktop-header.vue?vue&type=style&index=0&id=0ae68142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae68142",
  null
  
)

component.options.__file = "desktop-header.vue"
export default component.exports